<template>
    <CContainer class="d-flex align-items-center min-vh-100">
        <CRow class="w-100 justify-content-center">
            <CCol md="8">
                <div class="w-100">
                    <div class="clearfix">
                        <h1 class="float-left display-3 mr-4">۴۰۳</h1>
                        <h2 class="pt-3">متاسفیم!</h2>
                        <h4 class="text-muted">شما اجازه دسترسی به این صفحه را ندارید.</h4>
                    </div>
                </div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.mr-4{
    margin-left: 1.5rem !important;
    margin-right: none !important;
}
</style>